module.exports = __webpack_public_path__ + "img/detail_tour.cb35e775.svg";